export const MOBILITY_DASHBOARD                    : string = 'dashboard';
export const MOBILITY_DOSSIER_WORKING_LIST         : string = 'dossier-workings';
export const MOBILITY_DOSSIER_WORKING_DETAILS      : string = 'details';
export const MOBILITY_BACKOFFICE_STATIC            : string = 'backoffice-static';
export const MOBILITY_DOSSIER_WORKING_HISTORY      : string = 'history';
export const MOBILITY_DOSSIER_WORKING_LOGS         : string = 'logs';
export const MOBILITY_DOSSIER_WORKING_LOGS_DETAILS : string = 'details';
